/*
    theme.js additional custom functions and sections extending functionality
*/

window.theme = window.theme || {};
window.Shopify = window.Shopify || {};

(function () {
  "use strict";

  const appRoute = `${Shopify.routes.root}apps/jkcustom`;

  const wl = {
    key: { d: "wlst-ids", c: "cwlst-ids" },
    signedIn: false,
    loadItems() {
      const local = this.getStoredItem(this.key.d) || [];
      this.signedIn = document.querySelector("#ct-wlst-set") !== null;
      if (this.signedIn) {
        const saved = this.getStoredItem(this.key.c) || [];
        if (local.length > 0) {
          local.forEach((i) => saved.includes(i) && saved.push(i));
          localStorage.removeItem(this.key.d);
          this.update(saved);
        }
        return saved;
      } else {
        return local;
      }
    },

    async update(items) {
      try {
        const response = await fetch(`${appRoute}/wishlist`, {
          method: "PUT",
          body: JSON.stringify({ items }),
          headers: { "content-type": "application/json" },
        });
        if (response.status === 200) {
          this.storeItem(this.key.c, items);
          return true;
        }
      } catch (err) {
        console.err(err);
      }
      return false;
    },

    getStored() {
      return JSON.parse(
        this.signedIn
          ? localStorage.getItem(this.key.c)
          : this.getStoredItem(this.key.d) || "[]",
      );
    },

    storeItem(key, value, maxAge = 90 * 24 * 60 * 60 * 1000) {
      const result = { data: value };
      if (this.signedIn) result.expireTime = Date.now() + maxAge;
      localStorage.setItem(key, JSON.stringify(result));
    },

    getStoredItem(key) {
      const result = JSON.parse(localStorage.getItem(key));
      if (result) {
        if (result.expireTime && result.expireTime <= Date.now()) {
          localStorage.removeItem(key);
          return null;
        }
        return result.data;
      }
      return null;
    },
  };

  theme.jk.Wishlist = {
    items: wl.loadItems(),
    sk: wl.signedIn ? wl.key.c : wl.key.d,

    add(key) {
      return this.toggle(key, true);
    },
    remove(key) {
      return this.toggle(key, false);
    },
    async toggle(key, add) {
      const itemIdx = this.items.indexOf(key);
      add = add !== undefined ? add : itemIdx < 0;
      if (add) {
        if (itemIdx > -1) return true;
        this.items.push(key);
      } else {
        if (itemIdx < 0) return true;
        this.items.splice(itemIdx, 1);
      }
      wl.storeItem(this.sk, this.items);
      if (wl.signedIn) {
        const updated = await wl.update(this.items);
        if (!updated) {
          const oldIdx = this.items.indexOf(key);
          if (add && oldIdx < 0) {
            this.items.splice(oldIdx, 1);
          } else if (!add && oldIdx > -1) {
            this.items.push(key);
          }
          wl.storeItem(this.sk, this.items);
          return false;
        }
      }
      return true;
    },
    has(key) {
      return this.items.includes(key);
    },
    async clear(items) {
      const filtered = items
        ? [...this.items].filter((key) => !items.includes(key))
        : [];
      const result = wl.signedIn ? await wl.update(filtered) : true;
      if (result) {
        this.items = filtered;
        if (filtered.length === 0) {
          localStorage.removeItem(this.sk);
        } else {
          wl.storeItem(this.sk, filtered);
        }
      }
      return result;
    },
  };

  /*
   * FreeShippingBar - Custom free shipping bar
   */
  class JKShippingBar extends HTMLElement {
    connectedCallback() {
      this.allFree = this.hasAttribute("all-free");
      if (this.allFree && Number(this.dataset.cartPrice) === 0) {
        this.style.display = "none";
      }
      const fsbd = theme.jk?.addons?.freeShippingBar;
      const fsbdActive = fsbd?.active && fsbd?.amount;
      this.message = this.querySelector(".message");
      this.progress = this.querySelector(".progress");
      if (!fsbdActive || !this.message || !this.progress) {
        this.remove();
        return;
      }
      this.style = `--jsbBackground:${fsbd.background};--jsbFill:${fsbd.fill};`;
      document.addEventListener("cart:loaded", (evt) => {
        if (this.allFree)
          this.handleAllFree(evt.detail.cart.original_total_price);
        else this.updateBar(evt.detail.cart.original_total_price);
      });
    }

    handleAllFree(cartPrice) {
      if (cartPrice === 0) {
        this.style.display = "none";
      } else {
        this.message.innerHTML = theme.jk.addons.freeShippingBar.message;
        this.progress.style.width = "100%";
        this.style.display = "block";
      }
    }

    updateBar(cartPrice) {
      const fsbd = theme.jk.addons.freeShippingBar;
      const amountOff = Math.ceil(fsbd.amount * Shopify.currency.rate);
      if (cartPrice === 0) {
        this.message.innerHTML = fsbd.initial_message.replace(
          "#amount#",
          theme.Currency.formatMoney(amountOff, theme.settings.moneyFormat),
        );
        this.progress.style.width = "0%";
      } else if (cartPrice >= amountOff) {
        this.message.innerHTML = fsbd.message;
        this.progress.style.width = "100%";
      } else {
        this.message.innerHTML = fsbd.progress_message.replace(
          "#amount#",
          theme.Currency.formatMoney(
            amountOff - cartPrice,
            theme.settings.moneyFormat,
          ),
        );
        this.progress.style.width = `${(cartPrice / amountOff) * 100}%`;
      }
    }
  }
  customElements.define("jk-shipping-bar", JKShippingBar);

  // TODO => Do last
  theme.jk.InventoryCheck = class {
    selectors = {
      stockNonStock: ".cart__item.stock-non-stock",
      itemProperties: ".cart__item--properties",
      itemVariants: ".cart__item--variants",
      itemJson: "[data-line-item-json]",
    };
    endpoint =
      "https://gsn1f9s2fc.execute-api.us-east-2.amazonaws.com/default/CheckoutStockCheck";

    constructor(form) {
      this.cartForm = form;
      this.enabled = theme.jk.settings.inventoryCheckEnabled;
    }

    getInStock() {
      const cartItems = {};
      let count = 0;
      let ids = "";
      this.cartForm
        .querySelectorAll(this.selectors.stockNonStock)
        ?.forEach((cartItem, index) => {
          const propArr = Array.from(
            cartItem.querySelectorAll(this.selectors.itemProperties),
          );
          const inStock = propArr.find((prop) =>
            prop.innerText
              .replace(/\s/g, "")
              .includes("InventoryStatus:InStock"),
          );
          if (inStock) {
            let sizesString = "";
            const cartItemVariants = cartItem.querySelector(
              this.selectors.itemVariants,
            );
            cartItemVariants
              .querySelectorAll("div")
              .forEach(
                (sizeDiv) => (sizesString += " " + this.getSizeText(sizeDiv)),
              );
            const itemJson = JSON.parse(
              cartItem.querySelector(this.selectors.itemJson).innerHTML,
            );
            itemJson.inStock = inStock ? true : false;
            itemJson.dataLineId = index + 1;
            itemJson.btnParent = cartItem.querySelector(".cart__item-title");
            itemJson.sizesString = sizesString;
            cartItems[itemJson.variantId] = itemJson;
            ids += itemJson.variantId + ",";
            count++;
          }
        });
      return { inStock: { items: cartItems, ids }, count };
    }

    getSizeText(element) {
      var txt = "";
      [].forEach.call(element.childNodes, (v) => {
        if (v.nodeType == 3) txt += v.textContent.replace(/^\W*\n/, "");
      });
      return txt;
    }

    async checkStock(inStockItems) {
      let dispPopup = false;
      try {
        const response = await fetch(this.endpoint, {
          method: "POST",
          body: "fromID " + inStockItems.ids,
        });
        const data = await response.json();
        const outOfStockItems = data.variants.filter(
          (variant) =>
            inStockItems.items[variant.variantID].inStock &&
            variant.inStock === false,
        );
        if (outOfStockItems.length > 0) {
          const cart = await theme.cart.getCart();
          const popupLineItems = this.getItemProperties(
            inStockItems.items,
            outOfStockItems,
            cart.items,
          );
          if (popupLineItems.length > 0) {
            dispPopup = true;
            this.handlePopup(popupLineItems, outOfStockItems);
            await this.setItemProperties(popupLineItems);
            document.dispatchEvent(new CustomEvent("cart:build"));
            this.sendNotification(popupLineItems);
          }
        }
      } catch (err) {
        dispPopup = false;
      } finally {
        return dispPopup;
      }
    }

    getItemProperties(itemsData, outOfStockItems, cartItems) {
      return outOfStockItems.map((item) => {
        const itemData = itemsData[item.variantID];
        const cartItem = cartItems.find(({ key }) => key === itemData.itemKey);
        const itemProperties = cartItem.properties;
        itemProperties["Inventory Status"] = itemData.hasLeadTime
          ? "Needs Manufactured"
          : "In Production";
        if (itemData.hasLeadTime) {
          delete itemProperties["In Stock"];
          itemProperties["Manufacturing Timeline"] =
            itemData.defaultTimeline != ""
              ? itemData.defaultTimeline + " weeks"
              : "14 - 16 weeks";
          if (Object.keys(itemProperties).length === 3) {
            delete itemProperties["_boldOptionLocalStorageId"];
          }
        } else {
          itemProperties["Manufacturing Timeline"] =
            itemData.defaultTimeline != ""
              ? itemData.defaultTimeline + " Weeks"
              : "8 - 10 Weeks";
        }
        itemData.properties = itemProperties;
        return itemData;
      });
    }

    async setItemProperties(itemsData) {
      let cartRes;
      for (const item of itemsData) {
        if (cartRes?.items) {
          const cartItem = cartRes.items.find(
            ({ variant_id }) => variant_id === Number(item.variantId),
          );
          item.itemKey = cartItem.key ?? item.iteKey;
        }
        cartRes = await this.changeProperties({
          id: item.itemKey,
          properties: item.properties,
        });
      }
    }

    changeProperties(properties) {
      return theme.cart._updateCart({
        url: "".concat(theme.routes.cartChange, "?t=").concat(Date.now()),
        data: JSON.stringify(properties),
      });
    }

    async removeLineItem(dataKey) {
      try {
        const response = await fetch("/cart/update.js?t=".concat(Date.now()), {
          method: "POST",
          body: JSON.stringify({ updates: { [dataKey]: 0 } }),
          credentials: "same-origin",
          headers: {
            "Content-Type": "application/json",
            "X-Requested-With": "XMLHttpRequest",
            Accept: "application/json",
          },
        });
        const resData = await response.json();
        return resData;
      } catch (error) {
        return false;
      }
    }

    handlePopup(popupLineItems, outOfStockItems) {
      if (!this.modal) {
        this.modalEl = document.createElement("div");
        this.modalEl.id = "InventoryCheckModal";
        this.modalEl.className = "modal modal--square";
        this.modalEl.innerHTML = `<div class="modal__inner">
                    <div class="modal__centered">
                        <div class="modal__centered-content text-center">
                            <div class="inv_check-wrapper--modal">
                                <div class="content text-left">
                                    <h4 class="header">The following items have gone out of stock:</h4>
                                    <hr>
                                    <div class="no-stock-items"></div>
                                </div>
                                <button class="btn btn--small see-cart">
                                    See Cart
                                </button>
                            </div>
                        </div>
                        <button type="button" class="modal__close js-modal-close text-link">
                            <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-close" viewBox="0 0 64 64"><title>icon-X</title><path d="m19 17.61 27.12 27.13m0-27.12L19 44.74"/></svg>
                            <span class="icon__fallback-text">Close modal</span>
                        </button>
                    </div>
                </div>`;
        document.body.appendChild(this.modalEl);
        this.modal = new theme.Modals("InventoryCheckModal", "inventory-check");
        this.modalEl.querySelector(".see-cart").addEventListener(
          "click",
          function () {
            if (window.location.pathname !== "/cart") {
              location.href = "/cart";
            } //might have to open cart drawer here
            this.modal.close();
          }.bind(this),
        );
      }

      const nsItemsWrapper = this.modalEl.querySelector(".no-stock-items");
      nsItemsWrapper.innerHTML = "";
      popupLineItems.forEach((lItem) => {
        const itemEl = document.createElement("div");
        itemEl.className = "no-stock-item";
        if (lItem.hasLeadTime) {
          const titleDiv = document.createElement("div");
          titleDiv.className = "title";
          titleDiv.innerHTML = `<h4>${lItem.itemName}<span style="font-weight:normal">${lItem.sizesString}</span></h4>`;
          const rmBtn = document.createElement("button");
          rmBtn.type = "button";
          rmBtn.className = "ns-remove-btn";
          rmBtn.innerText = "Remove";
          rmBtn.setAttribute("aria-label", "Remove item from cart");
          rmBtn.setAttribute("title", "Remove and go to product");
          rmBtn.setAttribute("data-hover", "Remove and go to product");
          rmBtn.addEventListener(
            "click",
            function () {
              rmBtn.classList.add("is--loading");
              this.removeBtnClick(rmBtn, {
                itemKey: lItem.itemKey,
                url: lItem.productUrl,
              });
            }.bind(this),
          );
          titleDiv.appendChild(rmBtn);
          itemEl.appendChild(titleDiv);
        } else {
          itemEl.innerHTML = `<div class="title"><h4>${lItem.itemName}<span style="font-weight:normal">${lItem.sizesString}</span></h4></div>`;
        }
        const orderMessage = lItem.hasLeadTime
          ? `<p>You can still place an order as a leadtime of ${lItem.defaultTimeline} weeks has been selected.<br>If you would like to select a different timeline, remove the product from your cart and add it again with the new timeline.</p>`
          : `<p>You can still place an order as this size is being built. boots will be available to ship in approx. ${lItem.defaultTimeline} weeks from your order date.</p>`;
        const timeline = lItem.hasLeadTime
          ? `<div><strong>Manufacturing Timeline: </strong><span class="changed-text">${lItem.properties["Manufacturing Timeline"]}</span></div>`
          : "";
        const properties = `<div><div><strong>Inventory Status: </strong><span class="changed-text">${lItem.properties["Inventory Status"]}</span></div>${timeline}</div>`;
        itemEl.insertAdjacentHTML("beforeend", properties + orderMessage);
        nsItemsWrapper.appendChild(itemEl);
        nsItemsWrapper.appendChild(document.createElement("hr"));
        nsItemsWrapper.appendChild(
          this.createPlaceholder(lItem.variantId, lItem.sizesString),
        );
        nsItemsWrapper.appendChild(document.createElement("hr"));
      });

      theme.collapsibles.init(this.modalEl);
      this.modal.open();
      this.callGetSimilarProducts(outOfStockItems);
    }

    async removeBtnClick(btn, { itemKey, url }) {
      var res = await this.removeLineItem(itemKey);
      var res = true;
      if (res) {
        window.location.href = url;
      } else {
        btn.classList.remove("btn--loading");
        btn.innerText = "Unable to remove, please try again.";
      }
    }

    createPlaceholder(variantId, sizeString) {
      const placeholder = document.createElement("div");
      placeholder.className = "similar-products";
      placeholder.setAttribute("data-variant-id", variantId);

      placeholder.innerHTML = `
                <button type="button" class="collapsible-trigger collapsible-trigger--inline collapsible--auto-height text-left" aria-controls="simlarProducts-${variantId}">
                    <span class="collapsible-trigger__icon collapsible-trigger__icon--open" role="presentation">
                        <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon--wide icon-chevron-down" viewBox="0 0 28 16"><path d="m1.57 1.59 12.76 12.77L27.1 1.59" stroke-width="2" stroke="#000" fill="none"/></svg>
                    </span>
                    <span>Similar in stock products of size ${sizeString}</span>
                </button>
                <div id="simlarProducts-${variantId}" class="collapsible-content collapsible-content--all">
                    <div class="collapsible-content__inner grid grid--uniform aos-init aos-animate unload" data-variant-id="${variantId}"></div>
                </div>
            `;
      return placeholder;
    }

    callGetSimilarProducts(outOfStockItems) {
      fetch(this.endpoint, {
        method: "POST",
        body: "getSimilar " + JSON.stringify(outOfStockItems),
      })
        .then((res) =>
          res.json().then((variantData) => {
            variantData.variants.forEach((variant) => {
              const wrapper = document.querySelector(
                `.similar-products .grid[data-variant-id="${variant.variantID}"]`,
              );
              wrapper.innerHTML = this.createSimilarProducts(
                variant.similarProducts,
              );
              wrapper.classList.remove("unload");
              wrapper
                .querySelectorAll("img")
                ?.forEach((img) => (img.loading = "eager"));
            });
          }),
        )
        .catch((err) => {
          document
            .querySelectorAll(
              ".similar-products .grid[data-variant-id[data-variant-id]",
            )
            ?.forEach((w) => {
              w.innerHTML =
                '<span style="margin-left:22px;">Error loading products</span>';
              w.classList.remove("unload");
            });
        });
    }

    createSimilarProducts(similarProductsVariants) {
      if (!similarProductsVariants || similarProductsVariants.length === 0)
        return '<span style="margin-left:22px;">0 Products Found</span>';
      var products = [];
      var limit = Math.min(5, similarProductsVariants.length);
      for (var i = 0; i < limit; i++) {
        var variant = similarProductsVariants[i];
        var curVariantId = variant.id.split("/").pop();
        var product = {};
        product.url = `https://${window.Shopify.shop}/products/${variant.product.handle}?variant=${curVariantId}`;
        var widths = [180, 360, 540, 720, 900];
        product.image_responsive_url = theme.Images.buildImagePath(
          variant.product.featuredImage.url,
        );
        product.image_responsive_urls = theme.Images.buildImagePath(
          variant.product.featuredImage.url,
          widths,
        );
        product.image_aspect_ratio = 100;
        product.price_min = variant.price;
        product.unit_price = theme.Currency.formatMoney(variant.price);
        product.tags = "";
        product.title = variant.displayName;
        products.push(product);
      }
      var productMarkup = theme.buildProductGridItem(
        products,
        "small--one-half medium-up--one-third",
        "5",
        "(min-width: 769px) 20vw, 39vw",
      );
      return productMarkup;
    }

    sendNotification(popupLineItems) {
      const body =
        "popup " +
        JSON.stringify({
          from: "JK Boots",
          variants: popupLineItems.map((li) => {
            return {
              inStock: !li.inStock,
              name: li.itemName,
              variantID: li.variantId,
              productUrl: li.productUrl,
              variantTitle: li.sizesString.trim(),
            };
          }),
        });
      fetch(this.endpoint, { method: "POST", body }).catch(() => {});
    }
  };

  theme.jk.CartEditObserver = class {
    constructor(form) {
      this.cartForm = form;
      this.titleObserver = this.createTitleObserver();
      this.buttonObserver = this.createButtonObserver();
    }

    init() {
      document.addEventListener(
        "cart:loaded",
        function (evt) {
          this.cartForm
            .querySelectorAll(
              ".cart__item[data-leadtime], .cart__item[data-repair]",
            )
            ?.forEach((cartItem) => {
              this.titleObserver.observe(
                cartItem.querySelector(".cart__item-title"),
                {
                  childList: true,
                },
              );
            });
        }.bind(this),
      );
    }

    createTitleObserver() {
      return new MutationObserver((mutations, observer) => {
        mutations.forEach((record) => {
          record.addedNodes.forEach((element) => {
            if (element.classList.contains("bold_cart_edit_button")) {
              const parent = element.parentElement;
              if (
                parent.querySelector(".in-stock__property") &&
                parent.querySelectorAll(".cart__item--properties").length < 2
              ) {
                //element.remove();
                element.classList.add("hide");
              } else {
                element.addEventListener("click", (event) => {
                  this.buttonObserver.observe(
                    parent.querySelector(".bold_option_edit_container form"),
                    { childList: true },
                  );
                });
              }
              observer.disconnect();
            }
          });
        });
      });
    }

    createButtonObserver() {
      return new MutationObserver((mutations, observer) => {
        mutations.forEach((record) => {
          record.addedNodes.forEach((element) => {
            if (element.classList.contains("bold_option_set")) {
              this.handleEditOptions(record.target, element);
              const title = element.parentElement.parentElement.parentElement
                .querySelector(".cart__item-name")
                .innerText.toLowerCase();
              if (title.includes("custom"))
                new CustomsSizeListener(title, element);
            }
          });
        });
      });
    }

    handleEditOptions(target, element) {
      const timelines = theme.jk.settings.timelines;
      const cboxes = element.querySelectorAll(
        ".bold_option_checkbox > label .bold_option_title",
      );
      cboxes.forEach((cb) => {
        cb.innerText.toLowerCase().includes("in stock") &&
          cb.parentNode.parentNode.remove();
      });

      if (timelines.nonStockExtended || timelines.repairExtended) {
        const cartItem = target.parentNode.parentNode;
        const itemName = cartItem.querySelector(".cart__item-name").innerText;
        const timelineSelect = element.querySelector(
          '.bold_option_dropdown .bold_option_element select[name="properties[Manufacturing Timeline]"]',
        );
        if (
          timelineSelect &&
          timelines.nonStockExtended &&
          (cartItem.parentNode.parentNode.hasAttribute("leadtime") ||
            itemName === "Rebuild")
        ) {
          setTimelineValues(
            timelineSelect,
            "9 - 11",
            timelines.expeditedTimeline,
            `${timelines.normalTimeline} weeks`,
          );
        } else if (
          timelineSelect &&
          timelines.repairExtended &&
          cartItem.parentNode.parentNode.hasAttribute("repair") &&
          itemName !== "Rebuild"
        ) {
          setTimelineValues(
            timelineSelect,
            "7 - 9",
            timelines.expeditedRepairTimeline,
            `${timelines.normalRepairTimeline} Weeks`,
          );
        }
        optionsCleanup(target, cartItem, timelineSelect);

        function setTimelineValues(
          timelineSelect,
          key0Weeks,
          key0Value,
          key1Value,
        ) {
          // const key0 = timelineSelect.querySelector('option[data-option_value_key="0"]');
          const key1 = timelineSelect.querySelector(
            'option[data-option_value_key="0"]',
          ); //was 1
          // key0.innerText = key0.innerText.replace(key0Weeks, key0Value);
          // key0.value = key0Value + " Weeks";
          key1.innerText = key1Value;
          key1.value = key1Value;
        }

        function optionsCleanup(target, item, select) {
          const spinner = target.querySelector(".bold_spinner");
          if (spinner) {
            const propertiesArr = Array.from(
              item.querySelectorAll(".cart__item--properties"),
            );
            const timeline = propertiesArr.find((prop) =>
              prop.innerText.includes("Manufacturing Timeline:"),
            );
            const timelineValue = timeline.innerText.slice(24);
            select.value = timelineValue;
            spinner.remove();
          }
        }
      }
    }
  };

  class PDPRenderer {
    constructor(nodeId) {
      this.nodeId = nodeId || "MainContent";
      this.cachedPages = [];
    }

    renderPage(basePath, newParams, updateURLHash = true) {
      const currentParams = new URLSearchParams(window.location.search);
      const updatedParams = this.getUpdatedParams(currentParams, newParams);

      const url = `${basePath}?${updatedParams.toString()}`;
      const cachedPageUrl = (cachedPage) => cachedPage.url === url;
      const pageRender = this.cachedPages.some(cachedPageUrl)
        ? this.renderPageFromCache(cachedPageUrl)
        : this.renderPageFromFetch(url);

      if (updateURLHash) {
        history.pushState(
          {},
          "",
          `${window.location.pathname}${
            updatedParams && "?".concat(updatedParams)
          }`,
        );
      }

      return pageRender;
    }

    renderPageFromCache(url) {
      const cachedPage = this.cachedPages.find(url);
      const newContent = this.render(cachedPage.html);
      return Promise.resolve(newContent);
    }

    renderPageFromFetch(url) {
      return new Promise((resolve, reject) => {
        fetch(url)
          .then((response) => response.text())
          .then((responseText) => {
            const html = responseText;
            this.cachedPages.push({ html, url });
            const newContent = this.render(html);
            resolve(newContent);
          })
          .catch((err) => reject(err));
      });
    }

    render(html) {
      const newDom = new DOMParser().parseFromString(html, "text/html");
      const newContent = newDom.getElementById(this.nodeId);
      newContent
        .querySelectorAll('[loading="lazy"]')
        .forEach((image) => image.setAttribute("loading", "eager"));

      if (window.Station) {
        window.Station.Apps?.Tabs?.instances?.forEach((i) =>
          i.tabs.forEach((tab) => tab.remove()),
        );
      }

      document.getElementById(this.nodeId).replaceWith(newContent);
      return newContent;
    }

    getUpdatedParams(currentParams, newParams) {
      const clone = new URLSearchParams(currentParams);
      const preservedParams = ["sort_by", "q", "options[prefix]", "type"];

      for (const [key, value] of clone.entries()) {
        if (
          !newParams.getAll(key).includes(value) &&
          !preservedParams.includes(key)
        ) {
          clone.delete(key);
        }
      }

      for (const [key, value] of newParams.entries()) {
        if (!clone.getAll(key).includes(value) && value !== "") {
          clone.append(key, value);
        }
      }

      return clone;
    }
  }

  theme.jk.combinedListings = (() => {
    let pdpRenderer = null;
    let container = null;
    let isProductLoading = false;
    let variantSelects = [];
    let selectedOptions = [];
    let metaVariants = null;
    let combinedType = null;

    function init(pdpContainer, namespace, type) {
      if (pdpRenderer === null) {
        pdpRenderer = new PDPRenderer("MainContent");
      }
      combinedType = type;
      container = pdpContainer;
      container.off("variant-selects:change" + namespace);
      container.on("variant-selects:change" + namespace, onVariantChange);

      if (type === "options") {
        variantSelects = Array.from(
          container.querySelectorAll("variant-selects"),
        );
        selectedOptions = variantSelects.map((vs) => vs.selectedOption);
        const combinedMetaText = container.querySelector(
          ".product-block [data-combined-meta-variants]",
        )?.innerHTML;
        metaVariants = !!combinedMetaText ? JSON.parse(combinedMetaText) : null;
        theme.jk.combinedListings.initialized = true;
        theme.jk.combinedListings.available = true;
      }
    }

    function onVariantChange(event) {
      event.stopPropagation();
      let variant;
      if (combinedType === "options") {
        const evtOpt = event.detail.selectedOption;
        const key = selectedOptions
          .map((opt) => {
            if (opt.name === evtOpt.name) {
              opt.value = evtOpt.value;
            }
            return opt.value;
          })
          .join(" ");

        variantSelects.forEach((select) => {
          const inputs = select.querySelectorAll("input");
          inputs.forEach((input) => {
            const iKey = selectedOptions
              .map((opt) => (opt.name === input.name ? input.value : opt.value))
              .join(" ");
            const variant = metaVariants[iKey];
            if (variant?.available) {
              input.labels[0]?.classList.remove("disabled");
            } else {
              input.labels[0]?.classList.add("disabled");
            }
          });
        });

        variant = metaVariants[key];

        if (!variant || !variant.available || !variant.url) {
          theme.jk.combinedListings.available = false;
          disableCartButton();
          return;
        }
        variant.handle = variant.url.split("/").pop();
        theme.jk.combinedListings.available = true;
      } else {
        const input = event.detail.target;
        if (!input.dataset.productUrl) return;
        variant = {
          url: input.dataset.productUrl,
          handle: input.dataset.productUrl.split("/").pop(),
          id: Number(input.dataset.productId),
        };
      }
      startLoading(variant);
      renderPdp(variant);
    }

    function disableCartButton() {
      const stockInfoWrapper = container.querySelector(".stock-info-wrapper");
      stockInfoWrapper?.classList.add("hide");
      const cartBtns = container.querySelectorAll("[data-add-to-cart]");
      const cartBtn = cartBtns.length > 1 ? cartBtns[1] : cartBtns[0];
      if (!cartBtn) return;
      const cartBtnText = cartBtn.querySelector("[data-add-to-cart-text]");
      cartBtn.classList.add("disabled");
      cartBtn.disabled = true;
      cartBtnText.textContent = theme.strings.unavailable;
    }

    function startLoading(variant) {
      isProductLoading = true;
      const productUrl = variant.url;
      window.history.replaceState({}, "", productUrl);
      if (window.matchMedia("(max-width: 769px)").matches) {
        container
          .querySelector("[data-product-photos]")
          .classList.add("unload");
      } else {
        container
          .querySelector("[data-product-images] .product__photos")
          .classList.add("unload");
      }
    }

    function renderPdp(variant) {
      const productUrl = variant.url;
      pdpRenderer
        ?.renderPage(productUrl, new URLSearchParams(), false)
        .then(() => {
          theme.sections.register("product", theme.Product);
          reinitBold(variant);
          reinitTabs();
          const newProductSection = document.querySelector(".product-section");
          theme.collapsibles.init(newProductSection);

          theme.sections.register("slideshow-section", theme.SlideshowSection);
          theme.sections.register("video-section", theme.VideoSection);
          theme.sections.register("recently-viewed", theme.RecentlyViewed);
          theme.initGlobals();
          theme.rteInit();

          if (window.okeWidgetApi) {
            window.okeWidgetApi.initWidget(
              document.querySelector("[data-oke-star-rating]"),
            );
            window.okeWidgetApi.initWidget(
              document.querySelector("[data-oke-widget]"),
            );
          }
        })
        .catch((err) => {
          console.error(err);
          window.location.reload();
        })
        .finally(() => {
          isProductLoading = false;
        });
    }

    function reinitBold(variant) {
      if (window.BOLD && BOLD.common) {
        const productHandle = variant.handle;
        BOLD.options.app.productEventNamespaces = [];
        BOLD.options.app.unload();
        const id = { id: variant.id };
        Object.assign(BOLD.common.Shopify.products, {
          [productHandle]: id,
        });
        BOLD.options.app.init();
      }
    }
    function reinitTabs() {
      if (window.Station && window.Station.Apps?.Tabs?.instances) {
        window.Station.Apps.Tabs.instances.splice(
          0,
          window.Station.Apps.Tabs.instances.length,
        );
        container
          ?.querySelectorAll(".station-tabs")
          ?.forEach((tab) =>
            window.Station.Apps.Tabs.createInstance("#" + tab.id),
          );
      }
    }

    return { init };
  })();

  theme.jk.extendedOptions = (function () {
    let pageRenderer = null;
    let isProductLoading = false;
    let container = undefined;

    function init(productContainer, sectionId) {
      container = productContainer;
      if (!pageRenderer) pageRenderer = new PDPRenderer("MainContent");
      registerLinks();
    }

    function registerLinks() {
      document.querySelectorAll(".extended-options-link").forEach((a) => {
        if (a.hasAttribute("data-in-label")) {
          a.parentElement.previousElementSibling.className = "";
          a.parentElement.classList.remove("disabled");
        }
        a.addEventListener("click", (e) => {
          e.preventDefault();
          if (
            document.querySelector(".product-section").dataset.productId ===
              a.dataset.id ||
            isProductLoading
          )
            return;

          startLoading(a);
          renderProductPage(a);
        });
      });
    }

    function renderProductPage(a) {
      pageRenderer
        ?.renderPage(a.href, new URLSearchParams(), false)
        .then(() => {
          theme.sections.register("product", theme.Product);
          reinitBold(a);
          reinitTabs();
          const newProductSection = document.querySelector(".product-section");
          theme.collapsibles.init(newProductSection);

          theme.sections.register("slideshow-section", theme.SlideshowSection);
          theme.sections.register("video-section", theme.VideoSection);
          theme.sections.register("recently-viewed", theme.RecentlyViewed);
          theme.initGlobals();
          theme.rteInit();

          if (window.okeWidgetApi) {
            window.okeWidgetApi.initWidget(
              document.querySelector("[data-oke-star-rating]"),
            );
            window.okeWidgetApi.initWidget(
              document.querySelector("[data-oke-widget]"),
            );
          }
        })
        .catch((err) => {
          console.error(err);
          window.location.reload();
        })
        .finally(() => {
          isProductLoading = false;
        });
    }

    function startLoading(a) {
      isProductLoading = true;
      container.querySelector("#" + a.getAttribute("for")).checked = true;
      window.history.replaceState({}, "", a.href);
      if (window.matchMedia("(max-width: 769px)").matches) {
        container
          .querySelector("[data-product-photos]")
          .classList.add("unload");
      } else {
        container
          .querySelector("[data-product-images] .product__photos")
          .classList.add("unload");
      }
    }

    function reinitBold(a) {
      if (
        window.BOLD &&
        BOLD.common &&
        (BOLD.options.app.optionProducts[0].optionSets.length > 0 ||
          a.hasAttribute("data-leadtime"))
      ) {
        BOLD.options.app.productEventNamespaces = [];
        BOLD.options.app.unload();
        const id = { id: Number(a.dataset.id) };
        Object.assign(BOLD.common.Shopify.products, {
          [a.dataset.handle]: id,
        });
        BOLD.options.app.init();
      }
    }

    function reinitTabs() {
      if (window.Station && window.Station.Apps?.Tabs?.instances) {
        window.Station.Apps.Tabs.instances.splice(
          0,
          window.Station.Apps.Tabs.instances.length,
        );
        const stationTabs = container.querySelectorAll(".station-tabs");
        stationTabs.forEach((tab) =>
          window.Station.Apps.Tabs.createInstance("#" + tab.id),
        );
      }
    }

    return { init };
  })();

  theme.jk.BootVariants = class {
    endpoint =
      "https://32h49ns6l8.execute-api.us-east-2.amazonaws.com/default/GetWarehouseInventory";
    key = "9UR47e6q2AaC0W9KVXM5T8siDMsB1UhA4DS8rBMM";

    constructor(container, namespace, productId, variants, currentVariant) {
      this.container = container;
      this.namespace = namespace;
      this.productId = productId;
      this.variants = variants;
      this.currentVariant = currentVariant;
      this.selectElements = this.container.querySelectorAll(
        ".variant-input:has([data-variant-input])",
      );
      this.stockInfo = {
        wrapper: this.container.querySelector(".stock-info-wrapper"),
        attention: this.container.querySelector(".info-attention"),
        // content: this.container.querySelector(".info-content"),
      };

      this.inventoryStatusProp = document.querySelector("#inventoryStatusProp");
      this.manufacturingTimelineProp = document.querySelector(
        "#manufacturingTimelineProp",
      );

      this.stockNotifications = this.container.querySelector(
        "jk-stock-notifications",
      );

      BOLD.common.eventEmitter.on(
        "BOLD_OPTIONS_option_products_loaded",
        function () {
          document
            .querySelectorAll(
              "div .bold_option.bold_option_checkbox > label .bold_option_title",
            )
            .forEach((cb) => {
              if (cb.innerText.toLowerCase().includes("in stock")) {
                this.inStockCheckbox = cb.parentElement.querySelector(
                  "input[type=checkbox]",
                );
              }
            });
        }.bind(this),
      );

      this.init();
    }

    async init() {
      window.warehouse = window.warehouse || {};
      window.warehouse.inventory = window.warehouse.inventory || {};
      if (window.warehouse.timeout) clearTimeout(window.warehouse.timeout);

      if (
        this.currentVariant.inventory_quantity !== undefined &&
        !window.warehouse.inventory[this.productId]
      ) {
        this.setBaseState();
      }

      if (window.warehouse.inventory[this.productId]) {
        this.setInitialState(window.warehouse.inventory[this.productId]);
      } else {
        const { response, data } = await this.getWarehouseInventory();
        if (response && response.status === 429) {
          window.warehouse.timeout = setTimeout(
            async function () {
              const { data } = await this.getWarehouseInventory();
              this.setInitialState(data);
            }.bind(this),
            data.tryAgainIn,
          );
        } else {
          this.setInitialState(data);
        }
      }
    }

    async getWarehouseInventory() {
      try {
        const response = await fetch(
          `${this.endpoint}?product-id=${this.productId}`,
          {
            method: "GET",
            headers: { "x-api-key": this.key },
          },
        );
        const data = await response.json();
        return { response, data };
      } catch (error) {
        // console.log(error);
        return { response: null, data: null, error };
      }
    }

    setBaseState() {
      const optionTree = this.currentVariant.options.map((o) => ({}));
      const currentOptions = this.currentVariant.options;
      for (const variant of this.variants) {
        this.mapOptionTree(
          optionTree,
          {
            quantity: variant.inventory_quantity,
            available: variant.inventory_quantity > 0,
            continueSelling: variant.inventory_policy === "continue",
            id: variant.id,
            options: variant.options,
          },
          currentOptions,
        );
      }
      this.selectElements.forEach(this.updateInputState(optionTree));
    }

    setInitialState(data) {
      const isCoyote = Boolean(
        this.productId === "8482816098502" ||
        this.productId === "8525874430150" ||
        this.productId === "8482813018310",
      );
      if (
        !data ||
        (!data.isStockProduct && !data.isNonStockProduct && !isCoyote)
      )
        return;

      if (!window.warehouse.inventory[this.productId]) {
        window.warehouse.inventory[this.productId] = data;
      }

      this.isStockProduct = data.isStockProduct || isCoyote;
      this.isNonStockProduct = data.isNonStockProduct;

      this.inventoryProduct = {};

      const optionTree = this.currentVariant.options.map((opt) => ({}));
      const currentOptions = this.currentVariant.options;
      const curOpt1 = this.currentVariant?.option1;
      const curOpt2 = this.currentVariant?.option2;

      for (const variant of this.variants) {
        if (!variant) continue;

        const titleKey = variant.title
          .split("/")
          .map((s) => s.trim())
          .slice(-2)
          .join(" / ");
        const warehouseVariant = data.variants[titleKey];
        const continueSelling =
          warehouseVariant.inventoryPolicy === "CONTINUE" ||
          warehouseVariant.isTracked === false;
        const whVariant = {
          quantity: warehouseVariant.quantity,
          available: warehouseVariant.quantity > 0,
          continueSelling,
          id: variant.id,
          options: variant.options,
          option1: variant.option1,
          option2: variant.option2,
          option3: variant.option3,
        };

        this.mapOptionTree(optionTree, whVariant, currentOptions);
        this.inventoryProduct[variant.id] = whVariant;
      }
      this.container.on(
        "variantChange" + this.namespace,
        this.variantChange.bind(this),
      );
      this.selectElements.forEach(this.updateInputState(optionTree));
      this.updateMiscState(this.inventoryProduct[this.currentVariant.id]);
    }

    mapOptionTree(optionTree, variant, currentOptions) {
      const start = variant.options.length - 2;

      optionTree.forEach((option, index) => {
        if (index < start || variant.options[index] == null) return;
        let entry = option[variant.options[index]];
        if (entry === undefined) entry = false;

        if (
          index === start ||
          this.matchUpToIndex(variant.options, currentOptions, start, index)
        ) {
          entry = variant.available || entry;
        }
        option[variant.options[index]] = entry;
      });
    }

    matchUpToIndex(variantOptions, currentOptions, start, index) {
      for (let i = start; i < index; i++) {
        return (
          currentOptions[i] != null && currentOptions[i] === variantOptions[i]
        );
      }
    }

    createOptionTree() {
      return this.variants.reduce(
        (options, variant) => {
          const whVariant = this.inventoryProduct[variant.id];
          this.mapOptionTree(options, whVariant, this.currentVariant.options);
          return options;
        },
        this.currentVariant.options.map((opt) => ({})),
      );
    }

    variantChange(event) {
      const { variant } = event.detail;
      this.currentVariant = variant;
      if (variant) {
        // ?
        const optionsTree = this.createOptionTree();
        this.selectElements.forEach(this.updateInputState(optionsTree));
      }
      this.updateMiscState(this.inventoryProduct[variant?.id]);
    }

    updateInputState(optionsTree) {
      return (input) => {
        const index = isNaN(input.dataset.index)
          ? parseInt(input.dataset.index.substr(-1)) - 1
          : Number(input.dataset.index);
        const value = input.dataset.value;
        const options = optionsTree[index];
        const available = options[value];
        if (available === undefined) {
          // input.querySelector('input').classList.add('disabled')
          // input.querySelector('label').classList.add('disabled');
        } else if (available) {
          input.classList.remove("out-of-stock");
          input.classList.add("in-stock");
        } else {
          input.classList.remove("in-stock");
          input.classList.add("out-of-stock");
        }
      };
    }

    updateMiscState(variant) {
      this.stockNotifications?.setVariant(variant);
      if (!variant) {
        this.stockInfo.wrapper?.classList.add("hide");
        this.inventoryStatusProp.value = "Nonexistent";
        this.setTimeline("Nonexistent", "_");
        this.setISCheckbox(true);
      } else if (variant.quantity > 0) {
        this.setStockInfo(
          "Awesome, this size is available to ship!",
          "Great news, this product will ship in the next 1 - 5 business days. You will have the choice of several shipping speed options at check-out.",
        );
        this.inventoryStatusProp.value = "In Stock";
        this.setTimeline("None", "_");
        this.setISCheckbox(true);
      } else if (variant.available || variant.continueSelling) {
        if (this.stockInfo.wrapper.hasAttribute("custom-timeline")) {
          this.setStockInfo(
            `We will start hand building that size on an ${this.stockInfo.wrapper.dataset.stockTimeline} week timeline!`,
            `Choose your size and we'll start building on a ${this.stockInfo.wrapper.dataset.stockTimeline} week timeline.`,
          );
        } else {
          this.setStockInfo(
            `Made to order for you on an ${this.stockInfo.wrapper.dataset.stockTimeline} week timeline.`,
            `The size selected is not on the shelf and must be built and will be ready to ship in ${this.stockInfo.wrapper.dataset.stockTimeline} weeks. Place your order and as soon as it is finished it will ship straight to you.`,
          );
        }
        if (this.isStockProduct) {
          this.inventoryStatusProp.value = "In Production";
          this.setTimeline(
            this.manufacturingTimelineProp?.dataset?.defaultValue,
            "",
          );
        } else {
          this.inventoryStatusProp.value = "Needs Manufactured";
        }
        this.inStockCheckbox?.checked && this.setISCheckbox(false);
      } else {
        if (this.stockInfo.wrapper.hasAttribute("custom-timeline")) {
          this.stockInfo.wrapper?.classList.add("hide");
        } else {
          if (this.container.dataset.dropNotifications === "true") {
            this.setStockInfo(
              "Subscribe to our email list to know when we drop it next",
              "Unfortunately this product option is currently unavailable, however, we are working on making this available again in the near future. Please pick an alternative product or check back at a later date. Sorry for the inconvenience.",
            );
          } else {
            this.setStockInfo(
              "Sorry, this product is currently unavailable.",
              "Unfortunately this product option is currently unavailable, however, we are working on making this available again in the near future. Please pick an alternative product or check back at a later date. Sorry for the inconvenience.",
            );
          }
        }

        this.inventoryStatusProp.value = "Out Of Stock";
        this.setTimeline("None", "_");
        this.inStockCheckbox?.checked && this.setISCheckbox(false);
      }
    }

    setStockInfo(attention, content) {
      if (!this.stockInfo.wrapper) return;
      this.stockInfo.wrapper.classList.remove("hide");
      this.stockInfo.attention.innerHTML = attention;
      // this.stockInfo.content.innerHTML = content;
    }

    setISCheckbox(value) {
      if (this.inStockCheckbox) {
        this.inStockCheckbox.checked = value;
        this.inStockCheckbox.dispatchEvent(new Event("change"));
      }
    }
    setTimeline(value, leading) {
      if (this.manufacturingTimelineProp) {
        this.manufacturingTimelineProp.value = value;
        this.manufacturingTimelineProp.name = `properties[${leading}Manufacturing Timeline]`;
      }
    }
  };

  class CustomsSizeListener {
    default = {};
    left = {};
    right = {};
    constructor(customTitle, optionSet) {
      if (customTitle === "custom ironhide") this.onSafetyToe = true;
      optionSet
        .querySelectorAll(".bold_option.bold_option_dropdown")
        .forEach((dropdown) => {
          const title = dropdown
            .querySelector(".bold_option_title")
            .innerText.toLowerCase();
          if (title.includes("toe")) {
            const select = dropdown.querySelector("select");
            select.addEventListener(
              "change",
              this.onToeSelectChange.bind(this),
            );
          } else if (title.includes("size length")) {
            const width = title.includes("left")
              ? this.left
              : title.includes("right")
                ? this.right
                : this.default;
            const select = dropdown.querySelector("select");
            width.lengthDropdown = dropdown;
            select.addEventListener("change", (event) => {
              this.onSafetyToe &&
                this.onLengthChange(event.target.value, width);
              this.handleWidthOptions(event.target.value, width);
            });
          } else if (title.includes("size width")) {
            const width = title.includes("left")
              ? this.left
              : title.includes("right")
                ? this.right
                : this.default;
            width.dropdown = dropdown.querySelector("select");
          }
        });
    }

    onToeSelectChange(event) {
      const toeSelectVal = event.target.value?.toLowerCase();
      this.onSafetyToe = toeSelectVal?.includes("composite safety toe");
      this.handleSizeOnToeChange(this.default);
      this.handleSizeOnToeChange(this.left);
      this.handleSizeOnToeChange(this.right);
    }

    handleSizeOnToeChange(width) {
      if (width.lengthDropdown.classList.contains("bold_option_hidden")) {
        width.lengthHiddenState = true;
        this.onSafetyToe &&
          this.getSizeDropdownObserver("bold_option_hidden").observe(
            width.lengthDropdown,
            { attributes: true },
          );
      } else {
        const lengthValue = width.lengthDropdown.querySelector("select").value;
        if (this.onSafetyToe) {
          this.hideLengths(width.lengthDropdown);
          this.onLengthChange(lengthValue, width);
          width.dropdown.value = "";
        } else if (width.optionsHidden) {
          width.lengthDropdown
            .querySelectorAll("option.hide")
            .forEach((opt) => {
              opt.classList.remove("hide");
              opt.disabled = false;
            });
          width.dropdown.querySelectorAll("option.hide").forEach((opt) => {
            opt.classList.remove("hide");
            opt.disabled = false;
          });
          width.optionsHidden = false;
        }
        this.handleWidthOptions(lengthValue, width);
      }
    }

    hideLengths(lengthDropdown) {
      lengthDropdown.querySelectorAll("option")?.forEach((opt) => {
        if (opt.value < 5 || opt.value > 14) {
          opt.classList.add("hide");
          opt.disabled = true;
        }
      });
      lengthDropdown.querySelector("select").value = "";
    }

    onLengthChange(value, width) {
      const lengthValue = Number(value);
      if (lengthValue < 5 || lengthValue > 14) {
        if (width.optionsHidden) {
          width.dropdown.querySelectorAll("option.hide").forEach((opt) => {
            opt.classList.remove("hide");
            opt.disabled = false;
          });
          width.optionsHidden = false;
        }
        return;
      }

      const limitVal = lengthValue > 12 ? "4E" : "6E";
      const startVal = "D";
      let hide = true;
      width.dropdown.querySelectorAll("option").forEach((opt) => {
        if (opt.value === startVal) {
          hide = false;
        } else if (opt.value === limitVal || hide) {
          hide = true;
          opt.classList.add("hide");
          opt.disabled = true;
        } else if (opt.classList.contains("hide")) {
          opt.classList.remove("hide");
          opt.disabled = false;
        }
      });

      const l1 = width.dropdown.value === 1;
      if (
        width.dropdown.value !== "EE" &&
        ((l1 && width.dropdown.value < startVal) ||
          (!l1 && width.dropdown.value >= limitVal))
      ) {
        width.dropdown.value = "";
      }

      width.optionsHidden = true;
    }

    handleWidthOptions(value, width) {
      if (width.optionsHidden) {
        width.hidden8E = false;
        return;
      }
      const lengthValue = Number(value);
      if (lengthValue <= 11 && width.hidden8E) {
        width.hidden8E = false;
        width.dropdown
          .querySelector('option[value="8E"]')
          .classList.remove("hide");
        width.dropdown.querySelector('option[value="8E"]').disabled = false;
      } else if (lengthValue > 11 && !width.hidden8E) {
        width.hidden8E = true;
        width.dropdown
          .querySelector('option[value="8E"]')
          .classList.add("hide");
        width.dropdown.querySelector('option[value="8E"]').disabled = true;
        width.dropdown.value = "";
      }
    }

    getSizeDropdownObserver(classToWatch) {
      if (this.classObserver) return this.classObserver;
      this.classObserver = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (
            mutation.type === "attributes" &&
            mutation.attributeName === "class"
          ) {
            const currentState =
              mutation.target.classList.contains(classToWatch);
            this.handleDropdownClassChange(mutation.target, currentState);
          }
        });
      });
      return this.classObserver;
    }

    handleDropdownClassChange(dropdown, currentState) {
      const width =
        this.default.lengthDropdown === dropdown
          ? this.default
          : this.right.lengthDropdown === dropdown
            ? this.right
            : this.left;
      if (width.lengthHiddenState !== currentState) {
        width.lengthHiddenState = currentState;
        !currentState &&
          this.handleDropdownUnhidden(
            width,
            dropdown.querySelector("select")?.value,
          );
      }
    }

    handleDropdownUnhidden(width, value) {
      if (this.onSafetyToe) {
        this.hideLengths(width.lengthDropdown);
        this.onLengthChange(value, width);
        width.dropdown.value = "";
      } else if (width.optionsHidden) {
        width.lengthDropdown.querySelectorAll("option.hide").forEach((opt) => {
          opt.classList.remove("hide");
          opt.disabled = false;
        });
        width.dropdown.querySelectorAll("option.hide").forEach((opt) => {
          opt.classList.remove("hide");
          opt.disabled = false;
        });
        width.optionsHidden = false;
      }
    }
  }

  class LCarousel {
    selectors = {
      itemWrapper: ".items",
      item: ".item",
      actions: "[data-carousel-action]",
      actionTo: "[data-carousel-to]",
    };
    #defaults = {
      autoplay: false,
      interval: 3000,
      dots: true,
    };
    constructor(el, options = {}) {
      this.options = Object.assign({}, this.#defaults, options);
      this.carousel = el;
      this.inner = this.carousel?.querySelector(this.selectors.itemWrapper);
      this.items = Array.from(
        this.inner?.querySelectorAll(this.selectors.item),
      );
      this.transitioning = false;
      this.currentIndex = 0;
      this.actionBtns = this.carousel.querySelectorAll(this.selectors.actions);
      this.toDots = this.carousel.querySelectorAll(this.selectors.actionTo);
      this.#init();
    }

    #init() {
      this.items.forEach((item, idx) => {
        item.setAttribute("data-index", idx);
      });

      this.actionBtns?.forEach((action) =>
        action.addEventListener("click", () => {
          this.#onAction(action);
        }),
      );
      this.toDots?.forEach((action) =>
        action.addEventListener("click", () => {
          this.#toAction(action);
        }),
      );

      if (this.options.autoplay) {
        setInterval(() => {
          this.nextSlide();
        }, this.options.interval);
      }
    }

    rebuild() {
      this.items = Array.from(
        this.inner?.querySelectorAll(this.selectors.item),
      );
      this.toDots = this.carousel.querySelectorAll(this.selectors.actionTo);
      this.actionBtns = this.carousel.querySelectorAll(this.selectors.actions);
      this.#init();
      this.currentIndex = 0;
      this.toSlide(0);
    }

    #onAction(actionEl) {
      if (actionEl.dataset.carouselAction === "next") {
        this.nextSlide();
      } else if (actionEl.dataset.carouselAction === "prev") {
        this.prevSlide();
      }
    }

    #toAction(actionEl) {
      const toIdx = Number(actionEl.dataset.carouselTo);
      if (toIdx < this.items.length) {
        this.toSlide(toIdx);
      }
    }

    toggleDots(prev, current) {
      if (!this.toDots) return;
      this.toDots[prev]?.classList.remove("selected");
      this.toDots[current]?.classList.add("selected");
    }

    nextSlide() {
      if (this.transitioning) return false;

      const oldIdx = this.currentIndex;
      this.currentIndex =
        this.currentIndex === this.items.length - 1 ? 0 : this.currentIndex + 1;

      this.transitioning = true;
      this.inner.style = "transform: translateX(-100%)";

      this.afterTransition(() => {
        const item = this.items.shift();
        item && this.items.push(item);

        this.inner.innerHTML = "";
        this.items.forEach((el) => this.inner.appendChild(el));
        this.inner.style = "transition: none; transform:translateX(-0%)";
        this.transitioning = false;
      });
      this.toggleDots(oldIdx, this.currentIndex);
      return true;
    }

    prevSlide() {
      if (this.transitioning) return false;

      const oldIdx = this.currentIndex;
      this.currentIndex =
        this.currentIndex === 0 ? this.items.length - 1 : this.currentIndex - 1;

      this.transitioning = true;
      const item = this.items.pop();
      item && this.items.unshift(item);
      this.inner.innerHTML = "";
      this.items.forEach((el) => this.inner.appendChild(el));
      this.inner.style = "transition: none; transform:translateX(-100%)";

      setTimeout(() => {
        this.inner.style = "transform: translateX(-0%)";
      });
      this.afterTransition(() => {
        this.transitioning = false;
      });
      this.toggleDots(oldIdx, this.currentIndex);
      return true;
    }

    toSlide(index) {
      if (this.transitioning || index >= this.items.length) return false;

      const currentItem = this.items[0];
      const currentItemIndex = Number(currentItem.dataset.index);
      if (index === currentItemIndex) return false;

      const oldIdx = this.currentIndex;
      this.currentIndex = index;
      const arrIndex = this.items.findIndex(
        (item) => Number(item.dataset.index) === index,
      );
      this.transitioning = true;
      if (index > currentItemIndex) {
        this.inner.style = `transform: translateX(-${arrIndex * 100}%)`;
        this.afterTransition(() => {
          const items = this.items.splice(arrIndex);
          items && this.items.unshift(...items);
          this.inner.innerHTML = "";
          this.items.forEach((el) => this.inner.appendChild(el));
          this.inner.style = "transition: none; transform:translateX(-0%)";
          this.transitioning = false;
        });
      } else {
        const items = this.items.splice(arrIndex);
        const curIdx = items.length;
        items && this.items.unshift(...items);
        this.inner.innerHTML = "";
        this.items.forEach((el) => this.inner.appendChild(el));
        this.inner.style = `transition: none; transform: translateX(-${
          curIdx * 100
        }%)`;
        setTimeout(() => {
          this.inner.style = "transform: translateX(-0%)";
        });
        this.afterTransition(() => {
          this.transitioning = false;
        });
      }
      this.toggleDots(oldIdx, this.currentIndex);
      return true;
    }

    afterTransition(callback) {
      const listener = () => {
        callback();
        this.inner.removeEventListener("transitionend", listener);
      };
      this.inner.addEventListener("transitionend", listener);
    }
  }

  theme.jk.compare = {
    data: null,
    status: "idle",
    setData: async function () {
      if (this.data || this.status === "loading") return;
      this.status = "loading";
      fetch(`${appRoute}/compare?country=${Shopify.country}`, {
        method: "POST",
      })
        .then((response) => response.json())
        .then((result) => {
          this.data = result.product_models;
          this.status = "loaded";
        })
        .catch((err) => {
          this.data = null;
          this.status = "error";
        })
        .finally(() => {
          document.dispatchEvent(
            new CustomEvent("compare-data:loaded", {
              detail: { status: this.status },
            }),
          );
        });
    },
  };

  class ProductModel {
    column = null;
    cachedImages = [];
    constructor({ data, handle, parent }) {
      this.data = data;
      this.handle = handle;
      if (parent) this.column = parent.querySelector(".compare-column");

      this.selectedProduct = this.data.products[0];
      this.specKey =
        this.data.attributes.products[`${this.selectedProduct.id}`];
      this.specs = this.data.attributes.specs[this.specKey];
      this.#init();
    }

    #init() {
      if (!this.column) this.buildColumn();
      this.#initEvents();
      this.cacheInitialImage();
    }

    #initEvents() {
      const swatchInputs = this.column.querySelectorAll(".variant-input input");
      swatchInputs.forEach((input) =>
        input.addEventListener("change", (evt) => {
          this.selectedProduct = this.data.products[Number(input.dataset.key)];

          const imageElement = this.column.querySelector("image-element");
          const newImage =
            this.cachedImages.find((ci) => ci.id === this.selectedProduct.id)
              ?.el ?? this.buildImage(this.selectedProduct);
          imageElement.parentNode.replaceChild(newImage, imageElement);
          const buyBtn = this.column.querySelector(".buy-options .buy-btn");
          buyBtn.href = this.selectedProduct.url;
          buyBtn.ariaLabel = `Shop ${this.selectedProduct.title}`;
          this.column.querySelector(".price").innerHTML = this.getPriceText();

          const newKey =
            this.data.attributes.products[`${this.selectedProduct.id}`];
          if (newKey !== this.specKey) {
            this.specKey = newKey;
            this.specs = this.data.attributes.specs[this.specKey];
            input.dispatchEvent(
              new CustomEvent("specs:change", {
                bubbles: true,
                detail: {
                  specs: this.specs,
                  handle: this.handle,
                },
              }),
            );
          }

          AOS && AOS.refresh();
        }),
      );
    }
    buildColumn() {
      const column = document.createElement("div");
      column.className = "compare-column";
      this.imageElement = this.buildImage(this.selectedProduct, true);
      column.innerHTML = `
                <div class="image-section"><div class="product_image">${
                  this.imageElement
                }</div></div>
                <div class="compare_colors-wrapper">
                    <div class="compare_colors grid-product__colors grid-product__colors--${
                      this.data.id
                    }"></div>
                </div>
                <div class="buy-options">
                    <div class="price">${this.getPriceText()}</div>
                    <a href="${this.selectedProduct.url}" aria-label="Shop ${
                      this.selectedProduct.title
                    }" class="btn buy-btn btn--small"> Shop Now </a>
                </div>
            `;
      this.buildSwatches(column.querySelector(".compare_colors"));
      this.column = column;
    }
    buildSwatches(parent) {
      this.data.products.forEach((p, idx) => {
        const colorImageSrc = `https://${Shopify.cdnHost}/shop/files/${p.product_color}_50x50.jpg`;
        const swatchDiv = document.createElement("div");
        swatchDiv.className = "variant-input";
        const inputId = `product-${p.id}-color-${p.product_color}`;
        const input = `<input class="variant__input--color-swatch" id="${inputId}" type="radio" value="${
          p.product_color
        }" name="color_${this.selectedProduct.handle}" ${
          this.selectedProduct.id === p.id ? "checked" : ""
        } data-key="${idx}">`;
        const label = `<label for="${inputId}" class="color-swatch color-swatch--${p.product_color} color-swatch--with-image color-swatch--hover" style="background-color: ${p.product_color};background-image: url(${colorImageSrc});" data-color-swatch aria-label="${p.title}" title="${p.title}">
                    <span class="visually-hidden">${p.product_color}</span>
                </label>`;
        swatchDiv.innerHTML = input + label;
        parent.appendChild(swatchDiv);
        if (idx !== 0) {
          const onEvent = `mouseenter.pcid${this.data.handle}${idx}`;
          swatchDiv.on(onEvent, () => {
            this.cacheProductImage(this.data.products[idx]);
            swatchDiv.off(onEvent);
          });
        }
      });
    }
    cacheInitialImage() {
      this.cachedImages.push({
        id: this.selectedProduct.id,
        el: this.column.querySelector("image-element"),
      });
    }
    cacheProductImage(product) {
      if (!this.cachedImages.some((ci) => ci.id === product.id)) {
        this.cachedImages.push({
          id: product.id,
          el: this.buildImage(product),
        });
      }
    }
    buildImage(product, asString) {
      const imageUrl = product.featured_image.src;
      const src = theme.Images.buildImagePath(imageUrl);
      const srcset = theme.Images.buildImagePath(imageUrl, [360, 540]).join("");
      const markup = `<image-element data-aos="image-fade-in" data-aos-offset="150">
                <img class="image-element" width height src="${src}" srcset="${srcset}" loading="eager" alt="${product.title}" sizes="(min-width: 769px) 50vw, 100vw">
            </image-element>`;
      if (asString) return markup;

      const imageWrapper = document.createElement("div");
      imageWrapper.innerHTML = markup;
      return imageWrapper.querySelector("image-element");
    }
    getPriceText() {
      const amount = this.selectedProduct.price;
      const monthly = amount * 0.09025830753;
      const monthlyText =
        Shopify.country === "US" && Shopify.currency.active === "USD"
          ? ` or ${this.formatMoney(monthly)}/mo`
          : "";
      // return `From ${this.formatMoney(amount)}${monthlyText}`;
      return this.formatMoney(amount);
    }
    formatMoney(amount) {
      return theme.Currency.formatMoney(amount, theme.settings.moneyFormat);
    }
  }

  class JKProductCompare extends HTMLElement {
    allModelsMap = new Map();
    displayedModels = [];

    connectedCallback() {
      if (this.initialized) return;

      this.compareId = this.getAttribute("compare-id");
      this.isSimple = this.getAttribute("simple") === "true";
      this.isModal = this.getAttribute("modal") === "true";
      this.modelCount = Number(this.getAttribute("model-count"));
      this.view = this.querySelector(".compared__models-view");
      this.modelSelects = this.querySelectorAll("select.compare-model_select");

      if (this.isModal) {
        if (theme.Modals) {
          this.registerModal();
        } else {
          document.addEventListener(
            "page:loaded",
            this.registerModal.bind(this),
          );
        }
      } else {
        theme.jk.compare.setData();
      }

      if (theme.jk.compare.status === "loaded") {
        this.initialize();
      } else {
        this.view.classList.add("disabled");
        document.addEventListener("compare-data:loaded", (evt) => {
          if (evt.detail.status === "error")
            this.view.innerHTML = `<div class="errors">Error loading compare data</div>`;
          else this.initialize();
          this.view.classList.remove("disabled");
        });
      }
    }

    initialize() {
      this.querySelectorAll(".compared_model").forEach((el, index) => {
        const handle = el.dataset.model;
        const model = new ProductModel({
          data: theme.jk.compare.data[handle],
          handle,
          parent: el,
        });
        this.allModelsMap.set(handle, model);
        this.displayedModels.push({
          el,
          model,
          specs: this.view.querySelectorAll(`.specs-item[data-key="${index}"]`),
        });
      });

      this.modelSelects.forEach((select, idx) => {
        const selected = this.displayedModels[idx];
        if (select.value !== selected.model.handle) {
          select.value = selected.model.handle;
        }
        select.addEventListener("change", this.onSelectChange.bind(this));
      });
      this.addEventListener("specs:change", this.onSpecsChange.bind(this));
      this.initialized = true;
    }

    registerModal() {
      const modalTrigger = this.parentElement.querySelector(
        ".btn--open-compare_modal",
      );
      if (!modalTrigger) return;
      const modal = new theme.Modals(
        "ProductCompareModal-" + this.compareId,
        "product-compare-modal" + this.compareId,
      );
      modalTrigger.addEventListener("click", () => {
        theme.jk.compare.setData();
        modal.open();
      });
    }

    onSelectChange(evt) {
      const newHandle = evt.target.value;
      const viewIdx = Number(evt.target.dataset.key);

      let newModel = this.allModelsMap.get(newHandle);
      if (!newModel) {
        newModel = new ProductModel({
          data: theme.jk.compare.data[newHandle],
          handle: newHandle,
        });
        this.allModelsMap.set(newHandle, newModel);
      }

      const duplicateIdx = this.displayedModels.findIndex(
        (m) => m.model.handle === newHandle,
      );
      const selected = this.displayedModels[viewIdx];
      if (duplicateIdx > -1) {
        const duplicate = this.displayedModels[duplicateIdx];
        duplicate.model = selected.model;
        duplicate.el.innerHTML = "";
        duplicate.el.appendChild(duplicate.model.column);
        this.modelSelects[duplicateIdx].value = duplicate.model.handle;
        this.setSpecs(duplicate.model.specs, duplicate.specs);
      }
      selected.el.innerHTML = "";
      selected.el.appendChild(newModel.column);
      selected.model = newModel;
      this.setSpecs(selected.model.specs, selected.specs);
    }

    onSpecsChange(evt) {
      evt.stopPropagation();
      const dispModel = this.displayedModels.find(
        (m) => m.model.handle === evt.detail.handle,
      );
      this.setSpecs(evt.detail.specs, dispModel.specs);
    }

    setSpecs(specs, specElements) {
      specs.forEach((spec, idx) => {
        const img =
          spec.image && spec.image !== ""
            ? `<div class="img-wrapper"><img src="${spec.image}" width="50" height="auto"></div>`
            : "";
        const desc =
          spec.description && spec.description !== ""
            ? `<p class="desc">${spec.description}</p>`
            : "";
        specElements[idx].innerHTML = img + spec.value + desc;

        const parent = specElements[idx].parentElement;
        const equals = this.displayedModels.every(
          (dm) => dm.model.specs[idx].value === spec.value,
        );
        if (equals) {
          parent.classList.add("equal");
        } else if (parent.classList.contains("equal")) {
          parent.classList.remove("equal");
        }
      });
    }
  }

  customElements.define("jk-product-compare", JKProductCompare);

  class JKNewsletterForm extends HTMLElement {
    #form;
    #defaultError = "Error submitting form, please try again";
    status = "idle";

    connectedCallback() {
      if (this.#form) return;

      this.#form = this.querySelector("form");
      if (!this.#form) {
        this.#form = document.createElement("form");
        this.#form.append(...this.childNodes);
        this.appendChild(this.#form);
      }
      this.submitter = this.querySelector('button[type="submit"]');
      this.formErrors = this.querySelector(".errors");

      this.#form.id = this.getAttribute("form-id");

      if (window.Shopify?.captcha?.protect) {
        this.#form.submit = this.onSubmit.bind(this);
        this.submitter.addEventListener("click", this.addLoading.bind(this));
        const formObserver = new IntersectionObserver(
          (entries, observer) =>
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                window.Shopify.captcha.protect(this.#form);
                observer.unobserve(entry.target);
              }
            }),
          { root: null, threshold: 0.1 },
        );
        formObserver.observe(this.#form);
      } else {
        this.#form.addEventListener("submit", this.onSubmit.bind(this));
        this.#form.querySelector('input[name="form_type"]').remove();
      }
    }

    addLoading() {
      const valid = this.validateForm(new FormData(this.#form), false);
      if (valid && !this.submitter.classList.contains("btn--loading")) {
        this.submitter.classList.add("btn--loading");
      }
    }

    onSubmit(evt) {
      evt?.preventDefault();
      if (this.status === "loading") return;

      const formData = new FormData(this.#form);
      const valid = this.validateForm(formData, true);
      if (!valid) return;

      this.status = "loading";
      this.submitter?.classList.add("btn--loading");

      this.$fetch(formData)
        .then(this.handleResponse.bind(this))
        .finally(
          function () {
            this.submitter?.classList.remove("btn--loading");
            this.status = "idle";
          }.bind(this),
        );
    }

    handleResponse({ data, error, status }) {
      if (data && status === 200) {
        this.#form.innerHTML = data;
        this.formErrors = this.querySelector(".errors");
        this.submitter = this.querySelector('button[type="submit"]');
        this.submitter?.addEventListener("click", this.addLoading.bind(this));
      } else if (status === 400) {
        const errors = Object.entries(error?.fieldErrors);
        if (errors) {
          this.formErrors.innerHTML = `
            <ul style="margin-right:15px;">
            ${errors
              .map((err) => {
                const inputElement = this.querySelector(
                  `input[name=${err[0]}]`,
                );
                inputElement?.setAttribute("aria-invalid", true);
                inputElement?.classList.add("error");
                return `<li>${err[1]}</li>`;
              })
              .join("")}
            </ul>
            `;
          this.formErrors.classList.remove("hide");
        }
      } else {
        this.formErrors.innerHTML = `${error}`;
        this.formErrors.classList.remove("hide");
      }
    }

    validateForm(data, updateMsg) {
      this.clearErrorMessage();
      const type = data.get("type");
      let message = "";
      if (type === "email") {
        const email = data.get("email");
        if (email.trim() === "") {
          message = "Email is required";
        } else if (!this.emailValid(email)) {
          message = "Email is invalid";
        }
      } else if (type === "phone") {
        const number = data.get("phone");
        if (number.trim() === "") message = "Phone number is required";
        else if (!this.phoneValid(number)) message = "Phone number is invalid";
      }

      if (updateMsg && message !== "") {
        this.formErrors.innerHTML = message;
        this.formErrors.classList.remove("hide");

        const inputElement = this.querySelector(`input[name=${type}]`);
        inputElement?.setAttribute("aria-invalid", true);
        inputElement?.classList.add("error");

        return false;
      }
      return message === "";
    }

    emailValid(email) {
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    }

    phoneValid(number) {
      if (!/^\+?[\d\s\-()]{2,20}$/.test(number)) return false;
      const stripped = number.replace(/[^\d+]/g, "");
      return /^\+?[1-9]\d{1,14}$/.test(stripped);
    }

    clearErrorMessage() {
      if (!this.formErrors) return;
      this.formErrors.innerHTML = "";
      this.formErrors.classList.add("hide");

      this.querySelectorAll("input.error")?.forEach((input) => {
        input.setAttribute("aria-invalid", false);
        input.classList.remove("error");
      });
    }

    async $fetch(body) {
      try {
        const response = await fetch(`${appRoute}/newsletter`, {
          method: "POST",
          body,
          headers: { "X-Requested-With": "XMLHttpRequest" },
        });
        if (response.ok) {
          const data = await response.text();
          return { data, status: response.status };
        } else if (response.status === 400) {
          const data = await response.json();
          let error = data.error;
          if (data.field) {
            const fieldErrors = {};
            if (data.field === "email") {
              fieldErrors.email = "Email is invalid";
            } else if (data.field === "phone") {
              fieldErrors.phone = "Phone number is invalid";
            } else {
              fieldErrors.all = "Invalid request, please try again";
            }
            error = { fieldErrors };
          }
          return {
            error,
            status: 400,
          };
        }

        return { error: this.#defaultError, status: response.status };
      } catch (err) {
        console.err("Error in newsletter form submission", err);
        return { error: this.#defaultError, status: 500 };
      }
    }
  }

  customElements.define("jk-newsletter-form", JKNewsletterForm);

  class JKStockNotifications extends HTMLElement {
    successMarkup = `<h3>Notify me by email</h3><div class="success-message"><svg style="width:2.5rem;height:2.5rem;" aria-hidden="true" focusable="false" role="presentation" class="icon icon-circle-checkmark" viewBox="0 0 64 64"><defs><style>.cls-1{fill:none;stroke:#000;stroke-width:2px}</style></defs><path class="cls-1" d="M52.68 24.48A22 22 0 1 1 47 15.93M21 32l8.5 8.5L57 13"></path></svg></div><p><strong>Thank you for subscribing</strong></p><p>{{ message }}</p>`;
    connectedCallback() {
      this.view = "form";
      this.status = "none";
      this.modalTrigger = this.querySelector(".modal__open");
      const markup = this.querySelector("[data-modal-markup]");
      this.modalElement = markup.content.cloneNode(true);
      this.contentElement = this.modalElement.querySelector(
        ".modal__centered-content",
      );
      this.formMarkup = this.contentElement.innerHTML;

      markup.remove();

      if (theme.Modals) {
        this.#initModal();
      } else {
        document.addEventListener("page:loaded", this.#initModal.bind(this));
      }
    }

    #initModal() {
      this.#initForm();
      document.body.appendChild(this.modalElement);
      this.modal = new theme.Modals(
        `StockNotifModal-${this.dataset.product}`,
        `stock-notif-modal-${this.dataset.handle}`,
      );
      this.status = "created";
      this.modalTrigger.addEventListener("click", () => {
        if (this.view === "success" && this.status === "created") {
          this.contentElement.innerHTML = this.formMarkup;
          this.#initForm();
        }
        this.modal.open();
      });
    }

    #initForm() {
      this.form = {};
      this.form.error = this.contentElement.querySelector(".form-error");
      this.form.el = this.contentElement.querySelector(
        `#stockNotifForm-${this.dataset.product}`,
      );
      this.form.submitter = this.form.el.querySelector('button[type="submit"]');
      this.form.el
        .querySelector(`#snEmail-${this.dataset.product}`)
        .addEventListener("input", this.inputDisableToggle.bind(this));
      this.form.el.addEventListener("submit", this.onSubmit.bind(this));
      this.view = "form";
    }

    async onSubmit(event) {
      event.preventDefault();
      this.form.error.classList.add("hide");
      this.form.error.innerHTML = "";
      const formData = new FormData(event.target);
      const email = formData.get("notification_email");
      if (email.trim() !== "" && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        this.form.submitter.classList.add("btn--loading");
        const response = await fetch(appRoute + "/stock-notifications", {
          method: "POST",
          body: JSON.stringify({
            requestType: "variant_stock_notification",
            email,
            id: "",
            productId: this.dataset.product,
            variantId: this.dataset.variant,
          }),
          headers: { "content-type": "application/json" },
        });
        if (response.ok || response.status === 409) {
          const resData = await response.json();
          this.contentElement.innerHTML = this.successMarkup.replace(
            "{{ message }}",
            resData.subscription === "accepted"
              ? "Check your email to confirm your subscription. Once confirmed we will notify you as soon as this product is back on the shelf."
              : "You are all set to be notified as soon as this product is back on the shelf.",
          );
          this.view = "success";
        } else {
          let message =
            "There was an error submitting your email, please try again.";
          if (response.status === 400) {
            const data = await response.json();
            if (data.error?.email && data.error.email.length > 0) {
              message = data.error.email[0];
            }
          }
          this.form.error.innerHTML = message;
          this.form.error.classList.remove("hide");
        }
        this.form.submitter.classList.remove("btn--loading");
      } else {
        this.form.error.innerHTML = "Email format is invalid";
        this.form.error.classList.remove("hide");
      }
    }

    inputDisableToggle(event) {
      const empty = event.target.value.trim() === "";
      if (empty && !this.form.submitter.disabled) {
        this.form.submitter.disabled = true;
        this.form.submitter.setAttribute("aria-disabled", true);
      } else if (!empty && this.form.submitter.disabled) {
        this.form.submitter.disabled = false;
        this.form.submitter.setAttribute("aria-disabled", false);
      }
    }

    initListener(container) {
      container =
        container ??
        this.closest(
          `[data-section-type="product"][data-product-id="${this.dataset.product}"]`,
        );
      container.addEventListener("variantChange", (evt) => {
        const variant = evt.detail.variant;
        this.dataset.variant = variant?.id;
        if (variant) {
          if (variant.available) {
            this.modalTrigger.classList.add("hide");
          } else {
            this.modalTrigger.classList.remove("hide");
          }
        } else {
          this.modalTrigger.classList.add("hide");
        }
      });
    }

    setVariant(variant) {
      this.dataset.variant = variant?.id;
      if (!variant || variant.quantity > 0) {
        this.modalTrigger.classList.add("hide");
      } else {
        this.modalTrigger.classList.remove("hide");
      }
    }
  }

  customElements.define("jk-stock-notifications", JKStockNotifications);

  class FourColumnScroll extends HTMLElement {
    config = {
      pageDots: true,
      prevNextButtons: false,
      adaptiveHeight: false,
      autoPlay: false,
      childVertical: false,
      dragThreshold: 7,
      fade: false,
      friction: 0.8,
      initialIndex: 0,
      pauseAutoPlayOnHover: false,
      righToLeft: false,
      selectedAttraction: 0.14,
      setGallerySize: true,
      wrapAround: true,
      imagesLoaded: true,
    };

    connectedCallback() {
      this.namespace = this.dataset.sectionId;
      this.scrollContainer = this.querySelector(".four_col-scroll-container");
      this.scrollMainImage = this.querySelector(".item-main_image");
      this.scrollInstance = null;

      if (theme.utils) {
        this.addListener();
      } else {
        document.addEventListener("page:loaded", this.addListener.bind(this));
      }

      this.toggleFourColumns();
    }

    disconnectedCallback() {
      window.off("resize." + this.namespace);
    }

    addListener() {
      window.on(
        "resize." + this.namespace,
        theme.utils.debounce(300, this.toggleFourColumns.bind(this)),
      );
    }

    toggleFourColumns() {
      if (matchMedia("screen and (max-width: 768px)").matches) {
        if (!this.scrollInstance) {
          this.scrollInstance = new Flickity(this.scrollContainer, this.config);
          if (!this.scrollMainImage.complete) {
            this.imageLoadResizeHandler = this.resizeOnImageLoad.bind(this);
            this.scrollMainImage.addEventListener(
              "load",
              this.imageLoadResizeHandler,
            );
          }
        } else {
          this.scrollInstance.resize();
        }
      } else {
        if (this.scrollInstance) {
          this.scrollInstance.destroy();
          this.scrollInstance = null;
        }
      }
    }

    resizeOnImageLoad() {
      if (this.scrollInstance) {
        this.scrollInstance.resize();
        this.scrollMainImage.removeEventListener(
          "load",
          this.imageLoadResizeHandler,
        );
      }
    }
  }
  customElements.define("four-column-scroll", FourColumnScroll);

  class JKOffers extends HTMLElement {
    slideOpts = {
      wrapAround: true,
      imagesLoaded: true,
      setGallerySize: true,
      resize: true,
      dragThreshold: 7,
      friction: 0.8,
      selectedAttraction: 0.14,
      adaptiveHeight: true,
      pageDots: true,
      prevNextButtons: false,
      resize: true,
    };
    connectedCallback() {
      this.from = this.hasAttribute("data-product") ? "product_page" : "cart";
      if (this.hasAttribute("data-init")) {
        if (this.from === "product_page") {
          this.setupProductMarkup();
        } else {
          this.location = this.dataset.cart;
          if (this.location === "drawer") {
            this.cartOpenHandler = () => {
              document.removeEventListener(
                "drawerOpen.CartDrawer",
                this.cartOpenHandler,
              );
              this.cartOpenHandler = undefined;
              const cartItems = this.getCartItems();
              if (cartItems.length > 0) {
                this.setupCartData(cartItems);
              } else {
                this.cartLoadedHandler = () => {
                  document.removeEventListener(
                    "cart:loaded",
                    this.cartLoadedHandler,
                  );
                  this.cartLoadedHandler = undefined;
                  this.setupCartData();
                };
                document.addEventListener(
                  "cart:loaded",
                  this.cartLoadedHandler,
                );
              }
            };
            document.addEventListener(
              "drawerOpen.CartDrawer",
              this.cartOpenHandler,
            );
          } else {
            this.setupCartData();
          }
        }
      } else {
        this.initEvents();
      }
    }

    disconnectedCallback() {
      if (this.cartOpenHandler) {
        document.removeEventListener(
          "drawerOpen.CartDrawer",
          this.cartOpenHandler,
        );
        this.cartOpenHandler = undefined;
      }
    }

    initEvents() {
      this.itemsEl = this.querySelector(".offer-items");
      this.items = this.querySelectorAll(".offer-item");
      this.items.forEach((item) => {
        const addBtn = item.querySelector(".item-submit.btn");
        const timelineInput = item.querySelector('input[name="timeline"]');
        const select =
          item.querySelector("select") ||
          item.querySelector('input[name="id"]');
        select?.addEventListener("change", (evt) => {
          if (select.value && select.value !== "") {
            addBtn.classList.remove("not-allowed");
            select.classList.remove("form-error");
          }
          const optInput = select.querySelector(`[value="${select.value}"]`);
          if (timelineInput) {
            timelineInput.value =
              Number(optInput.dataset.qty) > 0
                ? "In Stock"
                : item.dataset.timeline;
          }
          const price = Number(optInput?.dataset.price);
          price &&
            (addBtn.querySelector("span").innerHTML =
              theme.Currency.formatMoney(price, theme.moneyFormat));
        });
        addBtn.addEventListener("click", async (evt) => {
          evt.preventDefault();

          if (!select.value || select.value === "") {
            select.classList.add("form-error");
            return;
          } else {
            select.classList.remove("form-error");
          }

          addBtn.classList.add("btn--loading");
          const addItem = {
            id: select.value,
            quantity: 1,
            properties: { _uxjk_id: this.from },
          };
          if (timelineInput) {
            const key =
              timelineInput.value === "In Stock"
                ? "Inventory Status"
                : "Manufacturing Timeline";
            addItem.properties[key] = timelineInput.value;
          }
          const result = await this.ajaxAddToCart({
            items: [addItem],
          });
          addBtn.classList.remove("btn--loading");
          if (this.from === "cart" && result === "success") {
            if (this.location === "page") {
              document.dispatchEvent(new CustomEvent("cart:build"));
            }
            if (this.flkty) {
              this.flkty.remove([item]);
            } else {
              item.remove();
            }
            if (this.itemsEl.querySelectorAll(".offer-item").length === 0) {
              this.remove();
            }
          }
        });
      });

      if (this.from === "product_page" || this.location === "page") {
        const options =
          this.from === "product_page"
            ? this.slideOpts
            : {
                ...this.slideOpts,
                adaptiveHeight: false,
                cellAlign: "left",
              };
        this.flkty = new Flickity(this.itemsEl, options);
      }
    }

    setupCartData(cartItems) {
      cartItems = cartItems || this.getCartItems();
      if (cartItems.length === 0) {
        return;
      }
      this.getRecommended(cartItems).then((data) => {
        if (!data?.result) return;
        const offerItems = this.setOfferItems(data.result);
        this.createOfferItemElements(offerItems);

        this.classList.remove("hide");
        this.removeAttribute("data-init");
        this.initEvents();
        if (AOS) AOS.refreshHard();
      });
    }

    getCartItems() {
      const cartForm = document.getElementById(
        this.location === "page" ? "CartPageForm" : "CartDrawerForm",
      );
      const cartItems = [];
      cartForm.querySelectorAll(".cart__item")?.forEach((cartItem) => {
        const id = cartItem.dataset.id?.split(":");
        cartItems.push({
          id: Number(id[0]),
          handle: id[1],
          title: cartItem.querySelector(".cart__item-name")?.innerText?.trim(),
          variantId: Number(cartItem.dataset.key?.split(":")[0]),
          collections: cartItem.dataset.collections
            .replace(/,\s*$/, "")
            .split(",")
            .map((c) => Number(c)),
        });
      });
      return cartItems;
    }

    setupProductMarkup() {
      const product = window.vtlsLiquidData?.product;
      if (product.id !== Number(this.dataset.product)) {
        return;
      }
      const products = [
        {
          id: product.id,
          handle: product.handle,
          title: product.title,
          collections: product.collectionIds,
          vendor: product.vendor,
          tags: product.tags,
        },
      ];
      this.getRecommended(products).then((data) => {
        if (!data?.result) return;
        const offerItems = this.setOfferItems(data.result);
        this.createOfferItemElements(offerItems);

        this.classList.remove("hide");
        this.removeAttribute("data-init");
        this.initEvents();
        if (AOS) AOS.refreshHard();
      });
    }

    setOfferItems({ first, second }) {
      if (!first && !second) return [];
      const oItems =
        second && first.offer.id.includes("boot-accessories")
          ? [first.products[0]]
          : first.products;
      if (second?.products && second.products.length > 0) {
        oItems.push(...second.products);
      }
      return oItems;
    }

    async getRecommended(products) {
      try {
        const response = await fetch(`${appRoute}/offers`, {
          method: "POST",
          body: JSON.stringify({ from: this.from, products }),
          headers: { "content-type": "application/json" },
        });
        const body = await response.json();
        return body;
      } catch (err) {
        return { result: null };
      }
    }

    createOfferItemElements(offerItems) {
      const itemsEl = document.createElement("div");
      itemsEl.classList = "offer-items";
      itemsEl.innerHTML = offerItems?.map(pdpMarkup.bind(this)).join("");
      this.appendChild(itemsEl);

      function pdpMarkup(product) {
        const variant = product.variants.nodes?.find((v) => v.availableForSale);
        if (!variant) return "";
        const variantId = variant.id.split("/").pop();
        const imageMarkup = theme.buildProductImage(
          {
            title: product.title,
            image_responsive_url: theme.Images.buildImagePath(
              product.featuredImage.url,
            ),
            image_responsive_urls: theme.Images.buildImagePath(
              product.featuredImage.url[(180, 360, 540)],
            ),
            image_aspect_ratio: 100,
          },
          "150px",
        );
        const url = `/products/${product.handle}?variant=${variant.id
          .split("/")
          .pop()}`;
        const priceNumber =
          Shopify.currency.active === "USD"
            ? variant.price.amount
            : Math.ceil(variant.price.amount * Shopify.currency.rate);
        const price = variant
          ? theme.Currency.formatMoney(
              priceNumber * 100,
              theme.settings.moneyFormat,
            )
          : undefined;

        // ${v.id === variant.id ? 'selected="selected"' : ""}
        const optionsMarkup = product.variants.nodes
          .map((v) => {
            const vPriceNum =
              Math.ceil(v.price.amount * Shopify.currency.rate) * 100;
            return v.availableForSale
              ? `<option data-qty="${v.quantityAvailable}" value="${v.id
                  .split("/")
                  .pop()}" data-price="${vPriceNum}">${v.title}</option>`
              : `<option disabled="disabled">${v.title} - Sold Out</option>`;
          })
          .join("");
        const propCheck =
          product.handle === "zipper" ||
          (product.title.toLowerCase().includes("belt") &&
            !product.title.toLowerCase().startsWith("the"));
        const timeline = "1 - 2 Weeks";
        const variantSelect =
          product.variants.nodes.length > 1
            ? `<select name="id" data-product-select>
                <option value="">Select Size</option>
                ${optionsMarkup}
              </select>`
            : `<input type="hidden" name="id" value="${variantId}">`;

        return `
                <div class="offer-item" ${
                  propCheck ? `data-timeline="${timeline}"` : ""
                }>
                    <a href="${url}" class="item-image">${
                      this.location === "drawer"
                        ? imageMarkup.replaceAll(
                            'data-aos-offset="150"',
                            'data-aos-offset="60" class="aos-init aos-animate"',
                          )
                        : imageMarkup
                    }</a>
                    <div class="item-details">
                        <div class="title__options">                      
                            <a href="${url}">${product.title}</a>
                            ${variantSelect}
                            ${
                              propCheck
                                ? `<input type="hidden" name="timeline" value="${
                                    variant.quantityAvailable > 0
                                      ? "In Stock"
                                      : timeline
                                  }" />`
                                : ""
                            }
                        </div>
                        <button type="button" class="btn btn--small item-submit not-allowed">
                            Add - <span>${price}</span>
                        </button>
                    </div>                    
                </div>
                `;
      }
    }

    async ajaxAddToCart(items) {
      try {
        const response = await fetch(theme.routes.cartAdd, {
          method: "POST",
          body: JSON.stringify(items),
          headers: { "Content-Type": "application/json" },
          credentials: "same-origin",
        });
        const data = await response.json();
        if (data.status === 422) {
          console.error(data);
        } else {
          document.dispatchEvent(new CustomEvent("ajaxProduct:added"));
          return "success";
        }
      } catch (err) {
        console.error(err);
      }
      return "error";
    }
  }
  customElements.define("jk-offers", JKOffers);

  class WishlistToggle extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector("button");
      this.textEl = this.button.querySelector("span.text");
      const [product, variant] = this.dataset.key.split(":");
      this.productId = product;

      this.toggleChecked(theme.jk.Wishlist.has(this.dataset.key));

      this.onClickListener = this.onClick.bind(this);
      this.button.addEventListener("click", this.onClickListener);
      if (product && variant) {
        this.productSection = this.closest(
          `[data-section-type="product"][data-product-id="${product}"]`,
        );
        this.onVariantChangeListener = this.onVariantChange.bind(this);
        this.productSection?.addEventListener(
          "variantChange",
          this.onVariantChangeListener,
        );
      }
    }

    disconnectedCallback() {
      this.button.removeEventListener("click", this.onClickListener);
      this.productSection?.removeEventListener(
        "variantChange",
        this.onVariantChangeListener,
      );
    }

    onClick() {
      this.button.disabled = true;
      theme.jk.Wishlist.toggle(this.dataset.key, !this.checked).then(
        (success) => {
          if (!success) this.toggleChecked(!this.checked);
          this.button.disabled = false;
        },
      );
      this.toggleChecked(!this.checked);
    }

    onVariantChange(evt) {
      if (!evt.detail.variant) return;
      this.dataset.key = `${this.productId}:${evt.detail.variant.id}`;
      this.toggleChecked(theme.jk.Wishlist.has(this.dataset.key));
    }

    toggleChecked(checked) {
      this.dataset.checked = checked;
      const label = checked ? "Remove from wishlist" : "Add to wishlist";
      this.checked = checked;
      this.button.classList.add("fill");
      this.button.title = label;
      this.button.ariaLabel = label;
      this.textEl && (this.textEl.innerHTML = label);
      if (checked) this.button.classList.add("fill");
      else this.button.classList.remove("fill");
    }
  }
  customElements.define("wl-toggle", WishlistToggle);

  const storage = {
    storeItem(key, value, maxAge = 90 * 24 * 60 * 60 * 1000) {
      const result = { data: value };
      result.expireTime = Date.now() + maxAge;
      localStorage.setItem(key, JSON.stringify(result));
    },

    getStoredItem(key) {
      const result = JSON.parse(localStorage.getItem(key));
      if (result) {
        if (result.expireTime && result.expireTime <= Date.now()) {
          localStorage.removeItem(key);
          return null;
        }
        return result.data;
      }
      return null;
    },
  };

  class UrgencyBlock extends HTMLElement {
    count = null;
    connectedCallback() {
      if (this.count === null) {
        this.count = this.#getCount();
      }
      const message = this.querySelector(".message");
      message.innerHTML = `<strong>${this.count}+</strong> have this in their cart`;
    }
    #getCount() {
      const allStored = JSON.parse(
        localStorage.getItem("urgeProductCartCount"),
      );
      if (allStored) {
        const index = allStored.products.findIndex(
          (p) => p.id === this.dataset.product,
        );
        let stored;
        if (index > -1) {
          if (allStored.products[index].expire <= Date.now()) {
            stored = this.#newStoredValue();
            allStored.products[index] = stored;
          } else {
            stored = allStored.products[index];
          }
        } else {
          stored = this.#newStoredValue();
          allStored.products.push(stored);
        }
        localStorage.setItem("urgeProductCartCount", JSON.stringify(allStored));
        return stored.count;
      } else {
        const newStored = this.#newStoredValue();
        const newAllStored = {
          expire: Date.now() + 24 * 60 * 60 * 1000,
          products: [newStored],
        };
        localStorage.setItem(
          "urgeProductCartCount",
          JSON.stringify(newAllStored),
        );
        return newStored.count;
      }
    }
    #newStoredValue() {
      return {
        id: this.dataset.product,
        count: Math.floor(Math.random() * (20 - 5) + 5),
        expire: Date.now() + 60 * 60 * 1000,
      };
    }
  }
  customElements.define("urgency-block", UrgencyBlock);

  class ExtendedSavings extends HTMLElement {
    connectedCallback() {
      if (theme.Currency && theme.settings) {
        this.render();
      } else {
        document.addEventListener("page:loaded", this.render.bind(this));
      }
    }
    render() {
      const amount = theme.Currency.formatMoney(
        Math.ceil(Number(this.dataset.amount) * 100 * Shopify.currency.rate),
        theme.settings.moneyFormat,
      );
      this.innerHTML = `
        <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-tag" viewBox="0 0 64 64"><path d="m46.69 10.34-10.55.07-25.8 25.8 17.45 17.45 25.8-25.8.07-10.55-6.97-6.97z"/><circle cx="43.95" cy="20.05" r="3.53"/><path d="M14.4 32.15 31.85 49.6"/></svg>
        <strong>Save ${amount}</strong> when you buy <strong>2</strong> pairs
      `;
    }
  }
  customElements.define("extended-savings", ExtendedSavings);

  theme.jk.VariantAvailability = (() => {
    const classes = {
      disabled: "disabled",
    };
    class availability {
      startOptionIndex = 0;
      constructor(args) {
        this.type = args.type;
        this.variantsObject = args.variantsObject;
        this.currentVariantObject = args.currentVariantObject;
        this.container = args.container;
        this.namespace = args.namespace;
        this.init();
      }

      init() {
        this.container.on(
          "variantChange" + this.namespace,
          this.setAvailability.bind(this),
        );
        this.setInitialAvailability();
      }

      createAvailableOptionsTree(variants, currentlySelectedValues) {
        return variants.reduce(
          (options, variant) => {
            options.forEach((option, index) => {
              if (
                index < this.startOptionIndex ||
                variant.options[index] == null
              )
                return;

              let entry = option.find(
                (opt) => opt.value === variant.options[index],
              );
              if (typeof entry === "undefined") {
                entry = { value: variant.options[index], soldOut: true };
                option.push(entry);
              }

              if (index === this.startOptionIndex) {
                entry.soldOut =
                  entry.soldOut && variant.available ? false : entry.soldOut;
              } else if (
                this.matchUpToIndex(
                  variant.options,
                  currentlySelectedValues,
                  index,
                )
              ) {
                entry.soldOut =
                  entry.soldOut && variant.available ? false : entry.soldOut;
              }
            });
            return options;
          },
          currentlySelectedValues.map((csv) => []),
        );
      }

      matchUpToIndex(variantOptions, currentOptions, index) {
        for (let i = this.startOptionIndex; i < index; i++) {
          if (
            currentOptions[i] == null ||
            currentOptions[i].value !== variantOptions[i]
          )
            return false;
        }
        return true;
      }

      setInitialAvailability() {
        const allInputs = this.container.querySelectorAll(
          ".variant-input-wrap:not(.combined)",
        );
        this.startOptionIndex = Number(allInputs[0].dataset.index);
        allInputs.forEach((group) => {
          this.disableVariantGroup(group);
        });

        const currentlySelectedValues = this.currentVariantObject.options.map(
          (value, index) => {
            return { value, index };
          },
        );

        const initialOptions = this.createAvailableOptionsTree(
          this.variantsObject,
          currentlySelectedValues,
        );
        initialOptions.forEach((values, index) => {
          this.manageOptionState(index, values);
        });
      }

      setAvailability(evt) {
        const { currentlySelectedValues, variant } = evt.detail;
        const valuesToManage = this.createAvailableOptionsTree(
          this.variantsObject,
          currentlySelectedValues,
        );
        valuesToManage.forEach((values, index) => {
          this.manageOptionState(index, values);
        });
      }

      manageOptionState(index, values) {
        const group = this.container.querySelector(
          '.variant-input-wrap[data-index="' + index + '"]',
        );
        values.forEach((obj) => {
          this.enableVariantOption(group, obj);
        });
      }

      enableVariantOption(group, obj) {
        // Selecting by value so escape it
        var value = obj.value.replace(
          /([ #;&,.+*~\':"!^$[\]()=>|\/@])/g,
          "\\$1",
        );

        if (this.type === "dropdown") {
          if (obj.soldOut) {
            group.querySelector('option[value="' + value + '"]').disabled =
              true;
          } else {
            group.querySelector('option[value="' + value + '"]').disabled =
              false;
          }
        } else {
          var buttonGroup = group.querySelector(
            '.variant-input[data-value="' + value + '"]',
          );
          var input = buttonGroup.querySelector("input");
          var label = buttonGroup.querySelector("label");

          // Variant exists - enable & show variant
          input.classList.remove(classes.disabled);
          label.classList.remove(classes.disabled);

          // Variant sold out - cross out option (remains selectable)
          if (obj.soldOut) {
            input.classList.add(classes.disabled);
            label.classList.add(classes.disabled);
          }
        }
      }

      disableVariantGroup(group) {
        if (this.type === "dropdown") {
          group.querySelectorAll("option").forEach((option) => {
            option.disabled = true;
          });
        } else {
          group.querySelectorAll("input").forEach((input) => {
            input.classList.add(classes.disabled);
          });
          group.querySelectorAll("label").forEach((label) => {
            label.classList.add(classes.disabled);
          });
        }
      }
    }

    return availability;
  })();

  customElements.define(
    "variant-selects",
    class VariantSelects extends HTMLElement {
      constructor() {
        super();
        this.initModal = this.initModal.bind(this);
      }

      connectedCallback() {
        this.addEventListener("change", (event) => {
          const target = this.getInputForEventTarget(event.target);
          this.updateSelectionMetadata(event);

          this.dispatchEvent(
            new CustomEvent("variant-selects:change", {
              detail: {
                event,
                target,
                selectedOption: this.selectedOption,
                // selectedOptionValues: this.selectedOptionValues,
              },
              bubbles: true,
            }),
          );
        });

        if (this.dataset.modalId) {
          if (theme.Modals) {
            this.initModal();
          } else {
            document.addEventListener(`page:loaded`, this.initModal);
          }
        }
      }

      initModal() {
        new theme.Modals(
          `HelpModal-${this.dataset.modalId}`,
          `help-modal-${this.dataset.modalId}`,
        );
        document.removeEventListener(`page:loaded`, this.initModal);
      }

      updateSelectionMetadata({ target }) {
        const { value, tagName } = target;
        if (tagName === "INPUT" && target.type === "radio") {
          const selectedSwatchValue = target
            .closest(`.variant-wrapper`)
            .querySelector("[data-selected-value]");
          if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
        }
      }

      getInputForEventTarget(target) {
        return target.tagName === "SELECT" ? target.selectedOptions[0] : target;
      }

      get selectedOption() {
        const input = this.querySelector(
          "select option[selected], fieldset input:checked",
        );
        return {
          name: input.name,
          value: input.value,
        };
      }

      get selectedOptionValues() {
        return Array.from(
          this.querySelectorAll(
            "select option[selected], fieldset input:checked",
          ),
        ).map(({ dataset }) => dataset.optionValueId);
      }
    },
  );

  customElements.define(
    "product-comparison",
    class ProductComparisonSection extends HTMLElement {
      constructor() {
        super();
        this.init = this.init.bind(this);
      }

      connectedCallback() {
        if (theme.Modals) {
          this.init();
        } else {
          document.addEventListener(`page:loaded`, this.init);
        }
      }
      init() {
        new theme.Modals(
          `ProductComparisonModal-${this.dataset.sectionId}`,
          `pcomparison-modal-${this.dataset.sectionId}`,
        );
        document.removeEventListener(`page:loaded`, this.init);
      }
    },
  );
})();
